import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IRepurposingDetail } from 'src/app/core/models/i-article-repurposing-detail';
import { ContentTypeRouterPaths } from 'src/app/shared/enums/content-type-router-paths';
import { ContentTypes } from 'src/app/shared/enums/content-types';

@Component({
  selector: 'app-repurposed-content',
  templateUrl: './repurposed-content.component.html',
  styleUrls: ['./repurposed-content.component.scss'],
})
export class RepurposedContentComponent {
  @Input() repurposedTo: IRepurposingDetail[];
  @Input() repurposedFrom: IRepurposingDetail[];
  @Input() contentType: ContentTypes;
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;

  constructor(private _router: Router) {}

  redirect(content: IRepurposingDetail) {
    this._router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this._router.navigate([
          '/content',
          ContentTypeRouterPaths[this.contentType.toLowerCase()],
          content.articleVersionId,
          'edit',
        ])
      );
  }
}
